module.exports = __webpack_public_path__ + "media/handshake-message/handshake-message1-mobile-5e025dd2.png";